import {createSlice} from "@reduxjs/toolkit"

const initialState = {
  "loading": false,
  "user": null,
  "method": "jwt",
  "tokens": null,
  "permissions": null,
  balances: null,
  balancesRefreshing: false,
  limits: null,
  allPermissions: null,
  otp: null,
  login: null,
  userDisabled: false,
  alfa: null,
  tokenLoading: false,
  endpointError: false,
  showTokenOfferAccepted: false,
  tokenOffer: null,
  getMy: null
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    restore: (state, action) => {

    },
    otpCheck: (state, action) => {

    },

    userLimit: (state, action) => {

    },

    userBalances: (state, action) => {

    },

    refreshUserBalances: (state, action) => {

    },
    logout(state) {
      state.getMy = null
    },
    login(state, payload) {

    },

    alfaLogin(state, payload) {

    },

    fetchGetMy(state, payload) {

    },

    refreshPermissions(state) {

    },

    setPermissions(state, action) {
      const {permissions, allPermissions} = action.payload
      state.permissions = permissions
      state.allPermissions = allPermissions
    },
    setUserLimit(state, action) {
      state.limits = action.payload.limits
    },

    setUserBalances(state, action) {
      state.balances = action.payload.balances
    },

    setBalancesRefreshing(state, action) {
      state.balancesRefreshing = action.payload
    },

    setAlfa(state, action) {
      state.alfa = action.payload
    },

    setEndpointError(state, action) {
      state.endpointError = action.payload
    },

    setShowTokenOfferAccepted(state, action) {
      state.showTokenOfferAccepted = action.payload
    },

    setTokenOffer(state, action) {
      state.tokenOffer = action.payload
    },

    setTokenLoading(state, action) {
      state.tokenLoading = action.payload
    },

    setGetMy(state, action) {
      state.getMy = action.payload
    },

    setUser(state, action) {
      const {user, tokens, permissions, balances, limits, allPermissions, otp} = action.payload

      state.user = user
      state.permissions = permissions
      state.tokens = tokens
      state.balances = balances
      state.limits = limits
      state.allPermissions = allPermissions
      state.otp = otp
    },
    setLoading(state, action) {
      const {payload} = action
      state.loading = payload
    },

    setOtp(state, action) {
      state.otp = action.payload
    },

    setLogin(state, action) {
      state.login = action.payload
    },

    setUserDisabled(state, action) {
      state.userDisabled = action.payload
    },
  },
})

const userReducer = userSlice.reducer

export {userSlice, userReducer}
